<template>
  <div class="page">
    <el-form label-width="80px">
      <el-form-item label="试卷标题">
        <el-input type="text" :value="data.examTitle" disabled></el-input>
      </el-form-item>
      <el-form-item label="开卷时间">
        <el-date-picker
          :value="data.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          disabled
        ></el-date-picker>
      </el-form-item>
      <el-row type="flex" justify="space-between">
        <el-col :span="4">
          <el-form-item label="参考总分">{{data.totalScores || 0}}分</el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="出卷人">{{data.author && data.author.nickname}}</el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="参考时间">{{data.time || 0}}分钟</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4">
          <div class="preview-title sub">试题</div>
          <div
            v-for="(item,index) in data.questionList"
            :key="index"
            style="margin-bottom:10px;border-bottom:1px solid #eee"
          >
            <el-form-item label="Question:"><pre>{{item.question}}</pre></el-form-item>
            <el-form-item
              label="Option:"
              v-for="(_item,index) in item.options"
              :key="index"
            >{{_item}}</el-form-item>
            <el-form-item label="Answer:"><pre>{{item.answer}}</pre></el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="参考得分">{{item.score}}分</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="参考时间">{{item.time}}分钟</el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import utils from "@/utils/index";
export default {
  data() {
    return {
      data: {}
    };
  },
  mounted() {
    utils.ajax.call(
      this,
      "/examDetail",
      { id: this.$route.query.id },
      (data, err) => {
        this.data = data;
      }
    );
  }
};
</script>

<style scoped lang="scss">
</style>
